export default __webpack_public_path__ + "static/media/success.158f1d33.svg";